export default "__VITE_ASSET__KK8cONj6__"